/**
 * Wingmate product — scoped gallery + bundle price sync.
 * Self-contained vanilla JS. Works on any product template that renders
 * `[data-wingmate]` with `.shop-main-image` / `.shop-thumbnail` gallery markup
 * and `.kc-offer__input[data-price]` bundle radios. Never touches global theme
 * state. Runs after DOM ready (deferred).
 */
(function () {
  'use strict';

  function initGallery(root) {
    var mains = Array.prototype.slice.call(root.querySelectorAll('.shop-image-zoom-wrapper'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('.shop-thumbnail'));
    if (!mains.length || !thumbs.length) return;

    function setActive(index) {
      var i = Math.max(0, Math.min(index, mains.length - 1));
      mains.forEach(function (el, idx) {
        el.classList.toggle('active', idx === i);
        var img = el.querySelector('img.shop-main-image');
        if (img) img.classList.toggle('active', idx === i);
      });
      thumbs.forEach(function (el, idx) {
        el.classList.toggle('active', idx === i);
      });
      // Reveal lazy-loaded image for the active slide if needed.
      var activeImg = mains[i] ? mains[i].querySelector('img.shop-main-image') : null;
      if (activeImg && activeImg.dataset.src && !activeImg.src) {
        activeImg.src = activeImg.dataset.src;
      }
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var idx = parseInt(thumb.getAttribute('data-index'), 10);
        if (!isNaN(idx)) setActive(idx);
      });
    });

    // Keyboard: left/right arrows adjust the active slide.
    root.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
      var active = mains.findIndex(function (el) { return el.classList.contains('active'); });
      var next = e.key === 'ArrowRight' ? active + 1 : active - 1;
      if (next >= 0 && next < mains.length) {
        e.preventDefault();
        setActive(next);
      }
    });

    thumbs.forEach(function(thumb, idx) {
      thumb.tabIndex = 0; thumb.setAttribute('role', 'button'); thumb.setAttribute('aria-label', 'View image ' + (idx+1));
      thumb.addEventListener('keydown', function(e) { if(e.key==='Enter'||e.key===' ') {e.preventDefault();setActive(idx);} });
    });
    setActive(0);
  }

  function money(valueCents) {
    var n = Number(valueCents);
    if (isNaN(n)) return null;
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      var fmt = window.Shopify.money_format || '${{amount}}';
      try {
        return window.Shopify.formatMoney(n, fmt);
      } catch (err) { /* fall through */ }
    }
    // Loose fallback: dollars & cents without locale grouping.
    return '$' + (n / 100).toFixed(2);
  }

  function initPriceSync(root) {
    var base = root.querySelector('[data-wm-base-price]');
    var radios = Array.prototype.slice.call(root.querySelectorAll('.kc-offer__input[data-price]'));
    if (!base || !radios.length) return;

    var currentEl = base.querySelector('.kc-base-price__current');
    var compareEl = base.querySelector('s');
    var saveEl = base.querySelector('.kc-base-price__save');

    function setPrice(input) {
      var price = money(input.getAttribute('data-price'));
      var compare = Number(input.dataset.compare) > Number(input.dataset.price) ? money(input.dataset.compare) : null;
      if (price && currentEl) currentEl.textContent = price;
      var p = Number(input.dataset.price), c = Number(input.dataset.compare);
      if (saveEl) { saveEl.textContent = 'SAVE ' + Math.round((c-p)/c*100) + '%'; saveEl.hidden = !(c > p); } 
      if (compareEl) {
        if (compare && compareEl.parentNode === base) {
          compareEl.textContent = compare;
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }
    }

    radios.forEach(function (input) {
      input.addEventListener('change', function () {
        if (input.checked) setPrice(input);
      });
    });
    var selected = radios.find(function (input) { return input.checked; });
    if (selected) setPrice(selected);
  }

  function submitFeedback(root) {
    var form = root.querySelector('.kc-wingmate-form');
    if (!form) return;
    var busy = false;
    var button = form.querySelector('button[type="submit"]');
    var errorBox = form.querySelector('.product-form__error-message-wrapper');
    var errorText = form.querySelector('.product-form__error-message');
    var spinner = form.querySelector('.loading__spinner');

    form.addEventListener('submit', async function (event) {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (busy) return;
      var selected = form.querySelector('.kc-offer__input:checked');
      if (!selected || selected.disabled) return;
      busy = true;
      if (button) { button.disabled = true; button.setAttribute('aria-busy', 'true'); }
      if (spinner) spinner.classList.remove('hidden');
      if (errorBox) errorBox.hidden = true;
      try {
        var routeRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        var response = await fetch(routeRoot + 'cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: selected.value, quantity: 1 }] })
        });
        var data = await response.json();
        if (!response.ok) throw new Error(data.description || data.message || 'Unable to add this offer. Please try again.');
        window.location.assign(routeRoot + 'checkout');
      } catch (error) {
        if (errorText) errorText.textContent = error.message || 'Unable to open checkout. Please try again.';
        if (errorBox) errorBox.hidden = false;
        busy = false;
        if (button) { button.disabled = false; button.removeAttribute('aria-busy'); }
        if (spinner) spinner.classList.add('hidden');
      }
    }, true);

    form.querySelectorAll('.kc-offer').forEach(function (offer) {
      offer.addEventListener('click', function (event) {
        event.preventDefault();
        if (busy) return;
        var input = offer.querySelector('.kc-offer__input');
        if (!input || input.disabled) return;
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
        form.requestSubmit();
      });
      offer.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          offer.click();
        }
      });
    });
  }

  function boot() {
    document.querySelectorAll('[data-wingmate]').forEach(function (root) {
      initGallery(root);
      initPriceSync(root);
      submitFeedback(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
